<template>
  <div class="teaching-score-confirm-handle">
    <div class="header">
      <NavBar :title="barTitle"
              border
              @back="hidePopover">
        <template #extra>
          <div v-if="isReady"
               class="extra">
            <el-button size="mini"
                       type="default"
                       :disabled="committing"
                       @click="handleReturn">退回重录</el-button>
            <el-button size="mini"
                       type="primary"
                       :disabled="committing"
                       @click="handleConfirm">成绩认定</el-button>
          </div>
        </template>
      </NavBar>
    </div>
    <div class="main">
      <div class="main-cont"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <TeachingScoreConfirmHandleMain :schedule-id="rowData.id"
                                        v-bind="$attrs"
                                        v-on="$listeners"
                                        @ready="handleReady"></TeachingScoreConfirmHandleMain>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '../../../../../../../widgets/NavBar'
import TeachingScoreConfirmHandleMain from './main'
export default {
  name: 'TeachingScoreConfirmHandle',
  components: {
    NavBar,
    TeachingScoreConfirmHandleMain
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isReady: false,
      committing: false
    }
  },
  computed: {
    barTitle () {
      return `${this.rowData.semesterName} - ${this.rowData.className} - ${this.rowData.siteName} - ${this.rowData.courseName}`
    }
  },
  methods: {
    hidePopover () {
      this.$emit('hidePopover')
    },
    handleReady () {
      this.isReady = true
    },
    handleReturn () {
      this.$confirm('确定要退回当前的成绩信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/teaching/score/confirm/schedule/return',
          method: 'post',
          data: this.$qs.stringify({
            scheduleId: this.rowData.id
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  this.$emit('hidePopoverAndRefresh')
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    },
    handleConfirm () {
      this.$confirm('确定要认定当前的成绩信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/teaching/score/confirm/schedule/confirm',
          method: 'post',
          data: this.$qs.stringify({
            scheduleId: this.rowData.id
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  this.$emit('hidePopoverAndRefresh')
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-confirm-handle {
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      .extra {
        .el-button {
          padding: 6px 15px;
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
